A list of top-level job categories for the provided scheme.

This query accepts browser tokens that include the `query:ontologies` or `query:enhanced-job-posting` scope.
